import { API_KEYS } from './map-providers';
import { IDPSettings } from '../map';
import { DPTomTom } from '../direction-providers/dp-tomtom';
import { DPHere } from '../direction-providers/dp-here';
import { DPBing } from '../direction-providers/dp-bing';
import { DPViamichelin } from '../direction-providers/dp-viamichelin';

export class DirectionProvider {
    getDirectionProvider(directionProviderSettings:IDPSettings){
        let router:any;
        switch(directionProviderSettings.selectedDirectionProvider){
            case 'Tom Tom Maps' : 
                router =  this.tomtomRoute(directionProviderSettings,false);
                break;
            case 'HERE':
                router =  this.hereRoute(directionProviderSettings);
                break;
            case 'Microsoft Bing Maps' :
                router = this.bingMapRoute(directionProviderSettings,false).router;
                break;
            case 'ViaMichelin' :
                router = this.viaMichelinRoute(directionProviderSettings);
                break;  
            default :
                // Default provider for Leaflet Routing is 'Openstreetmap'(when no value is passed)
                router =  null;
                break;
        }
        return router;
    }

     tomtomRoute(directionProviderSettings:IDPSettings,isUturnEnabled:boolean){
        const options ={
            travelMode: directionProviderSettings.selectedVehicle,
            routeType: directionProviderSettings.selectedDrivingDirection,
            avoid: directionProviderSettings.avoidTolls ? "tollRoads" : "",
        };
        //const keyTom=(isUturnEnabled)? "bVgsvyy5XE7Byy7r5YY0oZ67GfLaZRMz": API_KEYS.tomtom;
        const keyTom=(isUturnEnabled)? "8RmbGbuxLs4STSJvpgA2w8oBiYwA4f1G": API_KEYS.tomtom;       
        const tomtom = new DPTomTom();
        return tomtom.getTomTomRouting(keyTom,options);
    }

    /**
     * This function is used for both generating `Microsoft Bing Map` Direction Provider 
     * and fetching optimized waypoints
     * @param directionProviderSettings 
     * @param optimizeWaypoint 
     */
    bingMapRoute(directionProviderSettings:IDPSettings, optimizeWaypoints:boolean){
        const tollRoads = directionProviderSettings.avoidTolls ? "tolls" : "";
        const highways = directionProviderSettings.avoidHighways ? "highways" : "";
        const options ={
            travelMode: directionProviderSettings.selectedVehicle,
            avoid: `${highways},${tollRoads}`,
            optimizeWaypoints
        }
        const bing = new DPBing();
        return {
            router : bing.getBingRouting(API_KEYS.bing,options),
            optimizeWaypoint :  bing.getOptimizedWaypointOrder()
        }
    }
    private hereRoute(directionProviderSettings:IDPSettings) {
        let mode:string = 'fastest;car';
        if(directionProviderSettings.selectedDrivingDirection && directionProviderSettings.selectedVehicle){
            mode = `${directionProviderSettings.selectedDrivingDirection};${directionProviderSettings.selectedVehicle}`;
        }
        const options ={
            mode,
            avoidTransportTypes: directionProviderSettings.avoidTolls ? 'tollroad': ''
        }
        const here = new DPHere();
        return here.getHereRouting(API_KEYS.here,options);
    }
    private viaMichelinRoute(directionProviderSettings: IDPSettings) {
        const options = {
            veht       : directionProviderSettings.selectedVehicle,
            itit       : directionProviderSettings.selectedDrivingDirection,
            avoidTolls : directionProviderSettings.avoidTolls,
        };
        const here = new DPViamichelin();
        return here.getViaMichelinRouting(API_KEYS.viamichelin, options);
    }
}